// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"28b55b27","213":"28b55b27","450":"28b55b27","719":"28b55b27","971":"28b55b27","984":"28b55b27"}[chunkId] + ".chunk.css";
};